import React from 'react';

const History = ({ history }) => {
  return (
    <div className="row">
      <div className="col-12 text-center">
        <h1>History</h1>
        <div className="row">
          {history.map((img, index) => (
            <div key={index} className="col-6 col-md-4 col-lg-3 mb-4">
              <img src={img} alt={`dog-${index}`} className="img-fluid" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default History;
